import React from 'react';
import cn from 'classnames';
import Button from 'admin/components/common/Button';
import Text from 'admin/components/common/Text';
import css from './ResourceEditor.scss';

type Props = Omit<React.ComponentProps<typeof Button>, 'view' | 'size' | 'shape'> & {
	prominent?: boolean;
	icon?: React.ReactNode;
};

const ResourceActionButton = React.forwardRef<HTMLButtonElement, Props>(
	({ prominent = false, icon, children, className, style, ...props }, ref) => (
		<Button
			{...props}
			ref={ref}
			size="small"
			view={prominent ? 'primary' : 'empty'}
			color={prominent ? undefined : 'primary'}
			textSize={Text.size.label}
			textWeight={prominent ? Text.weight.semibold : Text.weight.normal}
			className={cn(css.action, className)}
			style={{
				...(!prominent ? { paddingInline: 10 } : {}),
				...style,
			}}
		>
			{icon && (
				<span className={css.actionIcon} aria-hidden="true">
					{icon}
				</span>
			)}
			{children}
		</Button>
	)
);

ResourceActionButton.displayName = 'ResourceActionButton';
export default ResourceActionButton;
